import {Component, Injector, Optional} from '@angular/core';

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";
import {WmsTranscludeDirective} from "../../page/wms-transclude/wms-transclude.directive";

const DEFAULT_CLS = 'app-prefab-container full-height';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-prefab-container',
  hostClass: DEFAULT_CLS
};

@Component({
  selector: '[wmPrefabContainer]',
  template: `<div class="app-ng-transclude" wmsTransclude>
              <ng-content></ng-content>
            </div>`,
  providers: [
  provideAsWidgetRef(PrefabContainerComponent)
  ],
  imports: [WmsTranscludeDirective],
  standalone: true,
  exportAs: 'wmPrefabContainer'
})
export class PrefabContainerComponent extends StylableComponent {
  static initializeProps = register('wm-prefab-container');

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
}

